import { render, staticRenderFns } from "./goodInprice.vue?vue&type=template&id=05dca081&scoped=true"
import script from "./goodInprice.vue?vue&type=script&lang=js"
export * from "./goodInprice.vue?vue&type=script&lang=js"
import style0 from "./goodInprice.vue?vue&type=style&index=0&id=05dca081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dca081",
  null
  
)

export default component.exports